import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useTranslation } from 'react-i18next';
import { UploadFileDialog } from 'shell/components';
import { SUBMISSION_ALLOWED_FILE_TYPES } from 'utils/constants';

const InstructorUploadSubmissionsDialog = ({ open, assignment, onClose, onClick }) => {
    const { course } = useApp();
    const { auth } = useAuth();
    const { t } = useTranslation('assignment');

    const handleClickUpload = (files) => {
        onClose();
        const folders = files.map((file) => {
            return {
                submitted_at: new Date().getTime(),
                files: [
                    {
                        ...file,
                        owner_account_id: auth.id,
                        course_id: course.id,
                        assignment_id: assignment.id,
                    },
                ],
            };
        });
        onClick(folders);
    };

    return (
        <UploadFileDialog
            allowedFileTypes={SUBMISSION_ALLOWED_FILE_TYPES}
            description={t(
                'submission.upload-file-description',
                'You can upload up to 600 files at a time. Please make sure each file is no larger than 30MB.'
            )}
            max={600}
            open={open}
            uploadButtonText={t('submission.start-processing', 'Start Processing')}
            title={t('submission.upload-submissions', 'Upload Submissions')}
            onClickUpload={handleClickUpload}
            onClose={onClose}
        />
    );
};

export default InstructorUploadSubmissionsDialog;
